import React from "react";
//import { Link } from "react-router-dom";
import "./profile.css";
import { AppSettings } from "./../../../config/app-settings.js";
//import GoogleMapReact from "google-map-react";
//import { Container, Row, Col, Form, Button, Image } from "react-bootstrap";
import auth from "../../../services/authservice";
import { connect } from "react-redux";
import GenderDropDown from "../../../components/user/GenderDropDown";
// import {getUser ,saveUser} from "../../../services/users.js";
import { loadCurrentUser } from "../../../store/users";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../components/panel/panel.jsx";
// import CountryDropDown from "../../components/user/CountryDropDown";
import ReusableTabNavs from "./../../../newcommon/ReusableTabNavs";
import ReusableTab from "./../../../newcommon/ReusableTab";
import About from "./About";
import Bank from "./Bank.js";
import Insurance from "./Insurance.js";
import Membership from "./Membership.js";
import ProfessionalInfo from "./ProfessionalInfo.js";
import Password from "./Password.js";
import LettersAvatar from "../../../newcommon/avatar/avatar.jsx";

import { TabContent } from "reactstrap";
import { toast } from "react-toastify";
// import LanguageDropDown from "../../components/user/LanguageDropDown";
import "react-phone-input-2/lib/bootstrap.css";
import "bootstrap/dist/css/bootstrap.css";
import "flatpickr/dist/themes/material_blue.css";
import { getCurrentUserAccountingSetting, saveAccountingSetting } from '../../../services/accountingsettings.js'
// import {
//   BankInput,
//   OrganizationInput,
//   InsuranceInput,
// } from "../../components/user/AutoSuggestion";
// import { getUser } from "../../services/users";

import { patchCompany, getCompany } from "../../../services/companies.js";
import { patchAccountant, getAccountant } from "../../../services/accountants";
import { getReception, patchReception } from "../../../services/receptions";
import { getSupervisor, patchSupervisor } from "../../../services/supervisors";
import { getOperator, patchOperator } from "../../../services/operators";
import { getScrumMaster, patchScrummaster } from "../../../services/scrummasters";
import { getQESHSupervisor, patchQESHSupervisor } from "../../../services/qeshsupervisors";
import { getQESHOfficer, patchQESHOfficer } from "../../../services/qeshofficers";

//import { getSkills } from "./../../services/skills.js";
import { getCode } from "country-list";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import "lity";
import "lity/dist/lity.min.css";

class Profile extends React.Component {
  static contextType = AppSettings;

  state = {
    dp: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      wrong: false,
      password: "",
      confirmPassword: "",
      activeTab: 1,
      currentUser: {
        Address: {
          address1: "",
          address2: "",
          address3: "",
          zip: "",
          city: "",
          state: "",
          country: "",
        },
        currency: "",
      },
      tabAbout: true,
      tabBank: false,
      tabInsurance: false,
      tabSkillsCertification: false,
      tabProfessionalInfo: false,
      tabMembership: false,
      loading: true,
      imageSrc: null,
      AccountingSetting: null,
      workingHours: [
        { day: "monday", startTime: "", endTime: "", open: false },
        { day: "tuesday", startTime: "", endTime: "", open: false },
        { day: "wednesday", startTime: "", endTime: "", open: false },
        { day: "thursday", startTime: "", endTime: "", open: false },
        { day: "friday", startTime: "", endTime: "", open: false },
        { day: "saturday", startTime: "", endTime: "", open: false },
        { day: "sunday", startTime: "", endTime: "", open: false },
      ],
      skills: [
        {
          skill: "",
          level: "",
          licenseNo: "",
          licenseValidTill: "",
        },
      ],
      certifications: [
        {
          certificate: "",
          certificateNo: "",
          certificateValidFrom: "",
          certificateValidTill: "",
        },
      ],
    };

    this.aboutUpdate = this.aboutUpdate.bind(this);
    this.bankUpdate = this.bankUpdate.bind(this);
    this.membershipUpdate = this.membershipUpdate.bind(this);
    this.insuranceUpdate = this.insuranceUpdate.bind(this);
    //.skillsCertificationUpdate = this.skillsCertificationUpdate.bind(this);
    this.passwordUpdate = this.passwordUpdate.bind(this);
    this.professionalInfoUpdate = this.professionalInfoUpdate.bind(this);

  }
  handleClick = (e) => {
    this.inputElement.click();
  };

  async componentDidMount() {
    const user = auth.getProfile();
    console.log("user:", user);
    await this.props.loadCurrentUser(user._id);
    const currentUser = await this.props.currentUser;

    this.context.handleSetAppContentClass("p-0");
    const data = await getCurrentUserAccountingSetting()
    this.setState({ AccountingSetting: data.data });
    console.log("current currency:", data.data);
    const updatedCurrentUser = {
      ...currentUser,
      currency: data.data?.currency
    };
    console.log("current ser:", updatedCurrentUser);


    this.setState({
      currentUser: updatedCurrentUser,
      birthDate: currentUser?.dateBirth?.substring(0, 10),
      officePhone: ""
    });

    // this code for Accountant role (need to be uncommented later)
    if (currentUser.role.name == "Accountant") {
      const {
        data: [accountant],
      } = await getAccountant(currentUser.accountNo);

      const data = { ...this.state.currentUser };
      data.insurance = accountant.insurance;
      data.bankInfo = accountant.bankInfo;
      data.membership = accountant.membership;
      console.log("Accountant==", accountant);
    }

    // this code for Reception role (need to be uncommented later)
    if (currentUser.role.name == "Reception") {
      const {
        data: [reception],
      } = await getReception(currentUser.accountNo);

      const data = { ...this.state.currentUser };
      data.insurance = reception.insurance;
      data.bankInfo = reception.bankInfo;
      this.setState({ currentUser: data });
      console.log("Reception==", reception);
    }

    // this code for QESHSupervisor role (need to be uncommented later)
    if (currentUser.role.name == "QESHSupervisor") {
      const {
        data: [QESHsupervisor],
      } = await getQESHSupervisor(currentUser.accountNo);

      const data = { ...this.state.currentUser };
      data.insurance = QESHsupervisor.insurance;
      data.bankInfo = QESHsupervisor.bankInfo;
      console.log("QESHSupervisor==", QESHsupervisor);
    }

    // this code for QESHOfficer role (need to be uncommented later)
    if (currentUser.role.name == "QESHOfficer") {
      const {
        data: [QESHofficer],
      } = await getQESHOfficer(currentUser.accountNo);

      const data = { ...this.state.currentUser };
      data.insurance = QESHofficer.insurance;
      data.bankInfo = QESHofficer.bankInfo;
      console.log("QESHOfficer==", QESHofficer);
    }

    // this code for Scrummaster role (need to be uncommented later)
    if (currentUser.role.name == "Scrummaster") {
      const {
        data: [scrummaster],
      } = await getScrumMaster(currentUser.accountNo);

      const data = { ...this.state.currentUser };
      data.insurance = scrummaster.insurance;
      data.bankInfo = scrummaster.bankInfo;
      console.log("Scrummaster==", scrummaster);
    }

    // this code for Operator role (need to be uncommented later)
    if (currentUser.role.name == "Operator") {
      const {
        data: [operator],
      } = await getOperator(currentUser.accountNo);

      const data = { ...this.state.currentUser };
      data.insurance = operator?.insurance;
      data.bankInfo = operator?.bankInfo;
      data.membership = operator?.membership;
      this.setState({ currentUser: data });
      console.log("Operator==", operator);
    }
    //this code for (Company & Solo) role
    if (currentUser.role.name == "Company" || currentUser == "Solo") {
      const {
        data: [company],
      } = await getCompany(currentUser.accountNo);
      console.log("company: ", company);
      this.setState({ __id: company._id });
      const data = { ...this.state.currentUser };
      data.bankInfo = company.bankInfo;
      data.companyInfo = company.companyInfo;
      data.membership = company.membership;
      data.professionalInfo = company.professionalInfo;
      data.skillsCertification = company.skillsCertification;
      // data.workingHours = company.workingHours;
      data.insurance = company.professionalInfo;
      this.setState({ currentUser: data });
      this.setState({ workingHours: company?.workingHours });
    }

    if (currentUser.role.name == "Supervisor") {
      const {
        data: [supervisor],
      } = await getSupervisor(currentUser.accountNo);
      console.log("supervisor: ", supervisor);
      this.setState({ __id: supervisor._id });
      const data = { ...this.state.currentUser };
      data.bankInfo = supervisor?.bankInfo;
      // data.companyInfo = supervisor.companyInfo; 
      data.membership = supervisor?.membership;
      // data.professionalInfo = supervisor.professionalInfo;         
      // data.skillsCertification = supervisor.skillsCertification;
      // data.workingHours = supervisor.workingHours;
      data.insurance = supervisor?.insurance;
      this.setState({ currentUser: data });
      // this.setState({ workingHours: supervisor?.workingHours });
    }

  }

  setActiveTab = (n) => this.setState({ activeTab: n });

  imageHandler = (e) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        this.setState({ dp: reader.result });
      }
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  saveCurrency = async () => {
    try {
      const dataToSubmit = this.state.AccountingSetting;
      dataToSubmit.currency = this.state.currentUser.currency;
      dataToSubmit.userNo = dataToSubmit.userNo?._id;
      delete dataToSubmit.__v;
      console.log("savong currency: ", dataToSubmit)
      await saveAccountingSetting(dataToSubmit);
    } catch (error) {
      console.log("error occured while updating currency: ", error);
    }
  }

  async aboutUpdate() {
    const { birthDate } = this.state;

    const toUpdate = {
      _id: this.state.currentUser.accountNo,
      email: this.state.currentUser.email,
      address1: this.state.currentUser.Address.address1,
      address2: this.state.currentUser.Address.address2,
      address3: this.state.currentUser.Address.address3,
      zip: this.state.currentUser.Address.zip,
      city: this.state.currentUser.Address.city,
      state: this.state.currentUser.Address.state,
      country: this.state.currentUser.Address.country,
      dateBirth: this.state.birthDate,
      language: this.state.currentUser?.language,
      gender: this.state.currentUser.gender,
      phone: this.state.currentUser.phones.phone,
      mobile: this.state.currentUser.phones.mobile,
      skype: this.state.currentUser.phones.skype,
      firstName: this.state.currentUser.contactName.first,
      lastName: this.state.currentUser.contactName.last,
      initials: this.state.currentUser.contactName.initials,
      mood: this.state.currentUser.mood,
      about: this.state.currentUser.about,
      function: this.state.currentUser.function,
      IBAN: "",
      bank: "",
      branchOfBank: "",
      subscription: "",
      subscriptionEndDate: "",
      businessName: "",
      chamberCommerceNo: "",
      taxPayerNo: "",
      website: "",
      size: "",
      industry: "",
      treatments: "",
      licenseNo: "",
      licenseValidTill: "",
      organizationAName: "",
      organizationAMemberNo: "",
      organizationBName: "",
      organizationBMemberNo: "",
    };

    try {
      switch (this.state.currentUser.role.name) {
        case "Company":
          await patchCompany(toUpdate, this.state.dp);
          break;

        case "Reception":
          await patchReception(toUpdate, this.state.dp);
          break;

        case "Accountant":
          await patchAccountant(toUpdate, this.state.dp);
          break;

        case "Solo":
          await patchCompany(toUpdate, this.state.dp);
          break;
        //  case "Scrumaster":
        //    await patchScrumaster(toUpdate, this.state.dp);
        //    break;

        //      case "QESHSupervisor":
        //     await patchQESHSupervisor(toUpdate, this.state.dp);
        //     break;

        //  case "QESHOfficer":
        //     await patchQESHOfficer(toUpdate, this.state.dp);
        //     break;
        case "Supervisor":
          await patchSupervisor(toUpdate, this.state.dp);
          break;
         case "Operator":
           await patchOperator(toUpdate, this.state.dp);
           break;

        default:
          break;
      }
      // Show success message
      toast.success("Profile updated successfully");

      // Optionally refresh user data
      await this.props.loadCurrentUser(this.state.currentUser._id);
    } catch (ex) {
      if (ex.response) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors });
        console.log(this.state.errors);
        toast.error("Error updating profile. Try again");

      }
    }
  }

  async bankUpdate() {
    const toUpdate = {
      _id: this.state.currentUser.accountNo,
      IBAN: this.state.currentUser.bankInfo.IBAN,
      bank: this.state.currentUser.bankInfo.bank,
      branchOfBank: this.state.currentUser.bankInfo.branchOfBank,

    };
    console.log(toUpdate);
    try {
      switch (this.state.currentUser.role.name) {
        case "Company":
          await patchCompany(toUpdate, this.state.dp);
          break;

        case "Reception":
          await patchReception(toUpdate, this.state.dp);
          break;

        case "Accountant":
          await patchAccountant(toUpdate, this.state.dp);
          break;

        case "Solo":
          await patchCompany(toUpdate, this.state.dp);
          break;
        //  case "Scrumaster":
        //    await patchScrumaster(toUpdate, this.state.dp);
        //    break;

        //      case "QESHSupervisor":
        //     await patchQESHSupervisor(toUpdate, this.state.dp);
        //     break;

        //  case "QESHOfficer":
        //     await patchQESHOfficer(toUpdate, this.state.dp);
        //     break;
        case "Supervisor":
          await patchSupervisor(toUpdate, this.state.dp);
          break;
         case "Operator":
           await patchOperator(toUpdate, this.state.dp);
           break;

        default:
          break;
      }
      // Show success message
      this.saveCurrency();
      toast.success("Profile updated successfully");


      // Optionally refresh user data
      await this.props.loadCurrentUser(this.state.currentUser._id);
    } catch (ex) {
      if (ex.response) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors });
        console.log(this.state.errors);
        toast.error("Error updating profile. Try again");

      }
    }

  }

  async insuranceUpdate() {
    const toUpdate = {
      _id: this.state.currentUser.accountNo,
      primInsuranceNo: this.state.currentUser.insurance.primInsuranceNo,
      primInsurance: this.state.currentUser.insurance.primInsurance,
      primInsuranceValidTill:
        this.state.currentUser.insurance.primInsuranceValidTill,
      secInsuranceNo: this.state.currentUser.insurance.secInsuranceNo,
      secInsurance: this.state.currentUser.insurance.secInsurance,
      secInsuranceValidTill:
        this.state.currentUser.insurance.secInsuranceValidTill,
    };
    console.log(toUpdate);
    try {
      switch (this.state.currentUser.role.name) {
        case "Company":
          await patchCompany(toUpdate, this.state.dp);
          break;

        case "Reception":
          await patchReception(toUpdate, this.state.dp);
          break;

        case "Accountant":
          await patchAccountant(toUpdate, this.state.dp);
          break;

        case "Solo":
          await patchCompany(toUpdate, this.state.dp);
          break;
        //  case "Scrumaster":
        //    await patchScrumaster(toUpdate, this.state.dp);
        //    break;

        //      case "QESHSupervisor":
        //     await patchQESHSupervisor(toUpdate, this.state.dp);
        //     break;

        //  case "QESHOfficer":
        //     await patchQESHOfficer(toUpdate, this.state.dp);
        //     break;
        case "Supervisor":
          await patchSupervisor(toUpdate, this.state.dp);
          break;
         case "Operator":
           await patchOperator(toUpdate, this.state.dp);
           break;

        default:
          break;
      }
      // Show success message
      toast.success("Profile updated successfully");

      // Optionally refresh user data
      await this.props.loadCurrentUser(this.state.currentUser._id);
    } catch (ex) {
      if (ex.response) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors });
        console.log(this.state.errors);
        toast.error("Error updating profile. Try again");

      }
    }
  }

  async professionalInfoUpdate() {
    const toUpdate = {
      _id: this.state.currentUser.accountNo,
      businessName: this.state.currentUser.companyInfo.businessName,
      chamberCommerceNo: this.state.currentUser.companyInfo.chamberCommerceNo,
      taxPayerNo: this.state.currentUser.companyInfo.taxPayerNo,
      website: this.state.currentUser.companyInfo.website,
      size: this.state.currentUser.companyInfo.size,
      industry: this.state.currentUser.companyInfo.industry,
      treatments: this.state.currentUser.professionalInfo.treatments,
      licenseNo: this.state.currentUser.professionalInfo.licenseNo,
      licenseValidTill:
        this.state.currentUser.professionalInfo.licenseValidTill,
      workingHours: this.state.workingHours,
    };
    console.log(toUpdate);
    try {
      switch (this.state.currentUser.role.name) {
        case "Company":
          await patchCompany(toUpdate, this.state.dp);
          break;

        case "Reception":
          await patchReception(toUpdate, this.state.dp);
          break;

        case "Accountant":
          await patchAccountant(toUpdate, this.state.dp);
          break;

        case "Solo":
          await patchCompany(toUpdate, this.state.dp);
          break;
        //  case "Scrumaster":
        //    await patchScrumaster(toUpdate, this.state.dp);
        //    break;

        //      case "QESHSupervisor":
        //     await patchQESHSupervisor(toUpdate, this.state.dp);
        //     break;

        //  case "QESHOfficer":
        //     await patchQESHOfficer(toUpdate, this.state.dp);
        //     break;
        //  case "Supervisor":
        //     await patchSupervisor(toUpdate, this.state.dp);
        //     break;
        //  case "Operator":
        //    await patchOperator(toUpdate, this.state.dp);
        //    break;

        default:
          break;
      }
      // Show success message
      toast.success("Profile updated successfully");

      // Optionally refresh user data
      await this.props.loadCurrentUser(this.state.currentUser._id);
    } catch (ex) {
      if (ex.response) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors });
        console.log(this.state.errors);
        toast.error("Error updating profile. Try again");

      }
    }
    //need to be uncommneted later after changing patchCompany of course
    //   const res = await patchCompany(toUpdate, this.state.currentUser.imageSrc);
    //   console.log(res);
  }

  async skillCertificationUpdate() {
    const toUpdate = {
      _id: this.state.currentUser.accountNo,
      organizationAName:
        this.state.currentUser.skillsCertification.organizationAName,
      organizationAMemberNo:
        this.state.currentUser.skillsCertification.organizationAMemberNo,
      organizationBName:
        this.state.currentUser.skillsCertification.organizationBName,
      organizationBMemberNo:
        this.state.currentUser.skillsCertification.organizationBMemberNo,
    };
    console.log(toUpdate);
    try {
      switch (this.state.currentUser.role.name) {
        case "Company":
          await patchCompany(toUpdate, this.state.dp);
          break;

        case "Reception":
          await patchReception(toUpdate, this.state.dp);
          break;

        case "Accountant":
          await patchAccountant(toUpdate, this.state.dp);
          break;

        case "Solo":
          await patchCompany(toUpdate, this.state.dp);
          break;
        //  case "Scrumaster":
        //    await patchScrumaster(toUpdate, this.state.dp);
        //    break;

        //      case "QESHSupervisor":
        //     await patchQESHSupervisor(toUpdate, this.state.dp);
        //     break;

        //  case "QESHOfficer":
        //     await patchQESHOfficer(toUpdate, this.state.dp);
        //     break;
        //  case "Supervisor":
        //     await patchSupervisor(toUpdate, this.state.dp);
        //     break;
        //  case "Operator":
        //    await patchOperator(toUpdate, this.state.dp);
        //    break;

        default:
          break;
      }
      // Show success message
      toast.success("Profile updated successfully");

      // Optionally refresh user data
      await this.props.loadCurrentUser(this.state.currentUser._id);
    } catch (ex) {
      if (ex.response) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors });
        console.log(this.state.errors);
        toast.error("Error updating profile. Try again");

      }
    }
  }

  async membershipUpdate() {
    const toUpdate = {
      _id: this.state.currentUser.accountNo,
      organizationAName: this.state.currentUser.membership.organizationAName,
      organizationAMemberNo:
        this.state.currentUser.membership.organizationAMemberNo,
      organizationBName: this.state.currentUser.membership.organizationBName,
      organizationBMemberNo:
        this.state.currentUser.membership.organizationBMemberNo,
    };
    console.log(toUpdate);
    try {
      switch (this.state.currentUser.role.name) {
        case "Company":
          await patchCompany(toUpdate, this.state.dp);
          break;

        case "Reception":
          await patchReception(toUpdate, this.state.dp);
          break;

        case "Accountant":
          await patchAccountant(toUpdate, this.state.dp);
          break;

        case "Solo":
          await patchCompany(toUpdate, this.state.dp);
          break;
        //  case "Scrumaster":
        //    await patchScrumaster(toUpdate, this.state.dp);
        //    break;

        //      case "QESHSupervisor":
        //     await patchQESHSupervisor(toUpdate, this.state.dp);
        //     break;

        //  case "QESHOfficer":
        //     await patchQESHOfficer(toUpdate, this.state.dp);
        //     break;
        case "Supervisor":
          await patchSupervisor(toUpdate, this.state.dp);
          break;
         case "Operator":
           await patchOperator(toUpdate, this.state.dp);
           break;

        default:
          break;
      }
      // Show success message
      toast.success("Profile updated successfully");

      // Optionally refresh user data
      await this.props.loadCurrentUser(this.state.currentUser._id);
    } catch (ex) {
      if (ex.response) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors });
        console.log(this.state.errors);
        toast.error("Error updating profile. Try again");

      }
    }
  }

  async passwordUpdate() {
    const toUpdate = {
      _id: this.state.currentUser.accountNo,
      password: this.state.password,
    };
    console.log(toUpdate);
    try {
      switch (this.state.currentUser.role.name) {
        case "Company":
          await patchCompany(toUpdate, this.state.dp);
          break;

        case "Reception":
          await patchReception(toUpdate, this.state.dp);
          break;

        case "Accountant":
          await patchAccountant(toUpdate, this.state.dp);
          break;

        case "Solo":
          await patchCompany(toUpdate, this.state.dp);
          break;
        //  case "Scrumaster":
        //    await patchScrumaster(toUpdate, this.state.dp);
        //    break;

        //      case "QESHSupervisor":
        //     await patchQESHSupervisor(toUpdate, this.state.dp);
        //     break;

        //  case "QESHOfficer":
        //     await patchQESHOfficer(toUpdate, this.state.dp);
        //     break;
        case "Supervisor":
          await patchSupervisor(toUpdate, this.state.dp);
          break;
         case "Operator":
           await patchOperator(toUpdate, this.state.dp);
           break;

        default:
          break;
      }
      // Show success message
      toast.success("Profile updated successfully");

      // Optionally refresh user data
      await this.props.loadCurrentUser(this.state.currentUser._id);
    } catch (ex) {
      if (ex.response) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors });
        console.log(this.state.errors);
        toast.error("Error updating profile. Try again");

      }
    }
  }

  // Reusable function to handle state changes
  handleStateChange = (key, value) => {
    this.setState((prevState) => {
      const newState = { ...prevState };
      if (key.includes(".")) {
        // If the key is nested, handle nested state change
        const keys = key.split(".");
        keys.reduce((currentLevel, currentKey, index, array) => {
          if (index === array.length - 1) {
            // If it's the last key, update the value
            currentLevel[currentKey] = value;
          } else {
            // If not the last key, move to the next level
            currentLevel[currentKey] = { ...currentLevel[currentKey] };
            return currentLevel[currentKey];
          }

          return currentLevel;
        }, newState);
      } else {
        // If the key is not nested, update directly
        newState[key] = value;
      }

      return newState;
    });
  };

  handleChange = ({ target: { name, value } }) => {
    console.log("name+ value", name, value);
    this.handleStateChange(name, value);
  };


  // Handle function to update workingHours
  handleWorkingHoursChange = (name, value, day) => {
    this.setState(prevState => {
      const updatedWorkingHours = prevState.workingHours.map(obj => {
        if (obj.day === day) {
          return {
            ...obj,
            [name]: value
          };
        }
        return obj;
      });

      console.log("Updated working hours:", updatedWorkingHours); // Debug log

      return { workingHours: updatedWorkingHours };
    });
  };

  handlePasswordChange = (e, field) => {
    this.setState({ [field]: e.target.value }, () => {
      if (this.state.password !== this.state.confirmPassword) {
        this.setState({ wrong: true });
      } else {
        this.setState({ wrong: false });
      }
    });
  };

  componentWillUnmount() {
    this.context.handleSetAppContentClass("");
    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }
  }


  render() {
    const { currentUser } = this.state;
    const { workingHours } = this.state;
    // console.log(currentUser);
    console.log("userrrrrrrrrrrrr profile=====");
    return (
      <div>
        {console.log(currentUser)}
        <div className="profile">
          <div className="profile-header">
            <div className="profile-header-cover"></div>
            <div className="profile-header-content p-4">
              <div className="d-flex align-items-start gap-5 flex-wrap mt-3">

                {/* LEFT COLUMN - Image + Name */}
                <div className="d-flex flex-column align-items-center" style={{ minWidth: '250px' }}>
                  <div className="profile-header-img mb-2">
                    <img
                      src={this.state.dp ? this.state.dp : currentUser?.imageSrc}
                      alt={currentUser?.contactName?.first}
                      className="img-fluid rounded"
                      style={{ objectFit: 'contain', maxHeight: '250px', width: '100%' }}
                    />
                  </div>
                  <h4 className="text-center text-white">{`${currentUser?.contactName?.first} ${currentUser?.contactName?.last}`}</h4>

                  <div className="img-uploader mt-2 text-center" onClick={this.handleClick}>
                    <input
                      ref={(input) => (this.inputElement = input)}
                      type="file"
                      name="dp"
                      id="dp"
                      onChange={this.imageHandler}
                      accept="image/*"
                    />
                    <span className="text-primary" style={{ cursor: 'pointer' }}>Click to upload image</span>
                  </div>
                </div>

                {/* RIGHT COLUMN - Scattered Fields in Columns */}
                <div className="flex-grow-1">
                  <div className="row g-4">
                    {/* Column 1: Function + Username */}
                    <div className="col-md-6">
                      <div className="d-flex flex-column gap-2">
                        <label htmlFor="function">Function</label>
                        <input
                          value={this.state.currentUser?.function || ""}
                          type="text"
                          name="currentUser.function"
                          onChange={this.handleChange}
                          className="form-control"
                          style={{ maxWidth: "35%" }}
                        />

                        {/* Username under Function */}
                        <h4 className="text-start text-white">{`${this.state.currentUser?.username}`}</h4>
                      </div>
                    </div>

                    {/* Column 2: Gender */}
                    <div className="col-md-6">
                      <div className="d-flex flex-column gap-2" style={{ maxWidth: "35%" }}>
                        <label htmlFor="gender">Gender</label>
                        <GenderDropDown
                          selectedValue={currentUser?.gender}
                          options={[
                            { value: "male", label: "Male" },
                            { value: "female", label: "Female" },
                            { value: "transgender", label: "Transgender" },
                          ]}
                          name="gender"
                          changeHandler={(e) => {
                            this.handleStateChange('currentUser.gender', e);
                          }}
                        />
                      </div>
                      <div className="d-flex flex-column gap-2">
                        <label htmlFor="dateBirth">Date of Birth</label>
                        <input
                          value={this.state.birthDate}
                          onChange={(e) => {
                            this.setState({ birthDate: e.target.value });
                            this.handleStateChange('currentUser.dateBirth', e.target.value + "T00:00:00.000Z");
                          }}
                          type="date"
                          name="birthDate"
                          className="form-control"
                          id="dateBirth"
                          style={{ maxWidth: "35%" }}
                        />
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
        <Panel>
          <PanelHeader >Profile</PanelHeader>
          <PanelBody>
            <ReusableTabNavs
              actions={this.actions}
              setActiveTab={(n) => this.setActiveTab(n)}
              activeTab={this.state.activeTab}
              navprops={
                currentUser?.role?.name === "Company" ||
                  currentUser?.role?.name === "Solo"
                  ? [
                    { label: "About", background: "#FFC69F" },
                    { label: "Bank", background: "#f0ee79" },
                    { label: "Professional Info", background: "#79f0b4" },
                    { label: "Membership", background: "#79f0d3" },
                    { label: "Password", background: "#79c1f0" },
                  ]
                  : [
                    { label: "About", background: "#FFC69F" },
                    { label: "Bank", background: "#f0ee79" },
                    { label: "Insurance", background: "#c5f079" },
                    // { label: "Professional Info", background: "#79f0b4" },
                    { label: "Membership", background: "#79f0d3" },
                    { label: "Password", background: "#79c1f0" },
                  ]
              }
            />
            <TabContent activeTab={this.state.activeTab}>
              <ReusableTab id={1}>
                <About
                  currentUser={currentUser}
                  handleChange={this.handleChange}
                  aboutUpdate={this.aboutUpdate}
                  handleStateChange={this.handleStateChange}
                />
              </ReusableTab>
              <ReusableTab id={2}>
                <Bank
                  currentUser={currentUser}
                  handleChange={this.handleChange}
                  handleStateChange={this.handleStateChange}
                  bankUpdate={this.bankUpdate}
                />
              </ReusableTab>
              {(currentUser?.role?.name === "Company" ||
                currentUser?.role?.name === "Solo") && (
                  <ReusableTab id={3}>
                    <ProfessionalInfo
                      currentUser={currentUser}
                      handleChange={this.handleChange}
                      professionalInfoUpdate={this.professionalInfoUpdate}
                      workingHours={workingHours}
                      handleWorkingHoursChange={this.handleWorkingHoursChange}
                    />
                  </ReusableTab>
                )}
              {(currentUser?.role?.name === "Company" ||
                currentUser?.role?.name === "Solo") && (
                  <ReusableTab id={4}>
                    <Membership
                      currentUser={currentUser}
                      handleChange={this.handleChange}
                      handleStateChange={this.handleStateChange}
                      membershipUpdate={this.membershipUpdate}
                    />
                  </ReusableTab>
                )}
              {!(
                currentUser?.role?.name === "Company" ||
                currentUser?.role?.name === "Solo"
              ) && (
                  <ReusableTab id={3}>
                    <Insurance
                      currentUser={currentUser}
                      handleChange={this.handleChange}
                      handleStateChange={this.handleStateChange}
                      insuranceUpdate={this.insuranceUpdate}
                    />
                  </ReusableTab>
                )}
              <ReusableTab
                id={
                  currentUser?.role?.name === "Company" ||
                    currentUser?.role?.name === "Solo"
                    ? 5
                    : 5
                }
              >
                <Password
                  password={this.state.password}
                  confirmPassword={this.state.confirmPassword}
                  handlePasswordChange={this.handlePasswordChange}
                  passwordUpdate={this.passwordUpdate}
                  wrong={this.state.wrong}
                />
              </ReusableTab>
            </TabContent>
          </PanelBody>
        </Panel>
      </div>
    );
  }
}

//export default Profile;
const mapStateToProps = (state) => ({
  currentUser: state.entities.users.currentUser,
});
const mapDispatchToProps = (dispatch) => ({
  loadCurrentUser: (id) => dispatch(loadCurrentUser(id)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Profile);
